import type API from '@resi-media/api-types';
import type { Immutable } from 'immer';
import type { Schedules } from '@studio/types';

type ContentScheduleResponse = API.Central.V3.Schedules.Get.ById.Response;

/**
 * Narrows a schedules GET response to the shared local `Schedules.Get.ContentSchedule`, which other
 * Central resources still return. The contract marks `occurrences` optional because Central only sets
 * it when both `startTime` and `endTime` are passed; Studio always queries with a range, so the field
 * is expected to be present. The empty-list default is defensive, not a conversion.
 */
export function toLocalContentSchedule(schedule: ContentScheduleResponse): Schedules.Get.ContentSchedule;
export function toLocalContentSchedule(schedule: Immutable<ContentScheduleResponse>): Schedules.Derived.ContentSchedule;
export function toLocalContentSchedule(
  schedule: Immutable<ContentScheduleResponse>
): Schedules.Derived.ContentSchedule {
  return { ...schedule, occurrences: schedule.occurrences ?? [] };
}
